import algoliasearch from 'algoliasearch/lite'
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js'
import { html } from 'htm/preact'
import { decodeSafeEntities } from '../utilities/string'

const searchClient = algoliasearch(
  window.ALGOLIA_APPLICATION_ID,
  window.ALGOLIA_CLIENT_API_KEY,
)
const autocompleteElement = document.getElementById('js-autocomplete')

const goToSearchPage = (value) => {
  if (!window.CURRENT_WEBSITE_LANG) {
    return
  }
}

const initAutocomplete = () => {
  if (!autocompleteElement) return

  const instance = autocomplete({
    container: autocompleteElement,
    placeholder: 'Type here...',
    detachedMediaQuery: 'none',
    debug: true,
    classNames: {
      submitButton:
        'c-global-search__submit bg-primary hover:bg-black z-10',
      input: 'js-autocomplete-input',
    },

    onSubmit() {
      let searchInput = document.querySelector('.js-autocomplete-input')
      if (searchInput?.value) {
        // search field value
        return goToSearchPage(searchInput.value)
      }
    },

    getSources({ query }) {
      return [
        {
          sourceId: 'items',
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: window.DEFAULT_ALGOLIA_INDEX,
                  query,
                  params: {
                    hitsPerPage: 5,
                  },
                },
              ],
            })
          },

          templates: {
            item({ item }) {
              const title = decodeSafeEntities(item.post_title)
              return html`<a href="${item.permalink}" class="aa-Link">${title}</div>`
            },
          },
        },
      ]
    },
  })

  // close on scroll to prevent items going over
  const handleAutocompleteScroll = () => {
    const searchBgElement = document.getElementById('js-global-search')
    if (searchBgElement) {
      searchBgElement.addEventListener('scroll', () => {
        if (searchBgElement.scrollTop > 0) {
          return autocompleteInstance.setIsOpen(false)
        }
        return autocompleteInstance.setIsOpen(true)
      })
    }
  }
  handleAutocompleteScroll()

  // make globally available
  window.autocompleteInstance = instance

  // handle keyboard navigation
  const searchInput = document.querySelector('.js-autocomplete-input')

  if (searchInput) {
    searchInput.addEventListener('keydown', (e) => {
      // on enter
      if (e.keyCode === 13) {
        e.preventDefault()
        const searchDropdown = document.querySelector('.aa-List')

        if (searchDropdown) {
          const activeDropdownEl = searchDropdown.querySelector(
            '[aria-selected="true"] a',
          )

          // dropdown item
          if (activeDropdownEl?.href) {
            return window.location.replace(activeDropdownEl.href)
          }
        }

        if (searchInput?.value) {
          // search field value
          return goToSearchPage(searchInput.value)
        }
      }
    })
  }
}

export default initAutocomplete
